<script lang="ts">import genericSpinner from "./assets/spinner.svg";
import { AppMode, appMode, cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { loggedIn, showLoading } from "@infinitro/global";
import { DotLottieSvelte } from "@lottiefiles/dotlottie-svelte";
import { onMount } from "svelte";
let { initPageLoadDisplayFor = appMode == AppMode.Player ? $stateUi.loading.playerInitPageLoadDisplayFor : $stateUi.loading.publicInitPageLoadDisplayFor, maxShowTime = 1e4, customClass = "", waitForLoggedIn = false } = $props();
// svelte-ignore state_referenced_locally
let show = $state(initPageLoadDisplayFor > 0);
// svelte-ignore state_referenced_locally
let showAnimation = $state(!waitForLoggedIn);
const onInitialPageLoad = async () => {
	if (initPageLoadDisplayFor <= 0) {
		show = false;
		return;
	}
	if (waitForLoggedIn) {
		let isLoggedIn = false;
		await new Promise((resolve) => {
			let unsub;
			unsub = loggedIn.subscribe((v) => {
				if (v !== undefined) {
					isLoggedIn = v === true;
					unsub?.();
					resolve();
				}
			});
		});
		if (isLoggedIn) return;
		showAnimation = true;
		await new Promise((resolve) => setTimeout(resolve, initPageLoadDisplayFor));
	} else {
		await new Promise((resolve) => setTimeout(resolve, initPageLoadDisplayFor));
	}
	show = false;
};
let timeoutTimer = undefined;
let fallback = $state(false);
onMount(() => {
	let unsub = showLoading.subscribe((v) => {
		if (!v && timeoutTimer) {
			clearTimeout(timeoutTimer);
			timeoutTimer = undefined;
		}
		if (v && !timeoutTimer) {
			timeoutTimer = setTimeout(() => showLoading.set(false), maxShowTime);
		}
	});
	if (initPageLoadDisplayFor > 0) {
		onInitialPageLoad();
	}
	return () => {
		unsub();
		if (timeoutTimer) {
			clearTimeout(timeoutTimer);
			timeoutTimer = undefined;
		}
	};
});
function preventEvents(e) {
	e.stopPropagation();
	e.preventDefault();
}
const lottieSpinner = cfgToThemeCdnPath(`/loading/loading.lottie`);
const svgSpinner = cfgToThemeCdnPath(`/loading/loading.svg`);
const lottieRenderConfig = { freezeOnOffscreen: false };
const customLoading = cfgToThemeCdnPath("/misc/logo.svg");
let useLottie = $derived($stateUi.loading.useLottie);
let useCustomLoading = $derived($stateUi.loading.useCustomLoading);
let useSubtleLogoAnimation = $derived($stateUi.loading.useSubtleLogoAnimation ?? false);
let spinner = $derived(fallback ? genericSpinner : useLottie ? lottieSpinner : svgSpinner);
</script>

{#if show || $showLoading}
	<!-- svelte-ignore a11y_no_static_element_interactions, a11y_click_events_have_key_events -->
	<div
		class={`loading-screen ${customClass}`}
		onclick={preventEvents}
		onwheel={preventEvents}
		ontouchmove={preventEvents}
		aria-label="Loading..."
	>
		{#if showAnimation || $showLoading}
			{#if useCustomLoading}
				<img
					src={customLoading}
					alt="..."
					class="spinner"
					class:subtle-pulse={useSubtleLogoAnimation}
					onerror={() => (fallback = true)}
				/>
			{:else if useLottie && spinner && !fallback}
				<div class="lottie-container">
					<DotLottieSvelte
						src={spinner}
						loop
						autoplay
						speed={1}
						renderConfig={lottieRenderConfig}
					/>
				</div>
			{:else if spinner}
				<img src={spinner} alt="..." class="spinner" onerror={() => (fallback = true)} />
			{/if}
		{/if}
	</div>
{/if}

<style>
	.loading-screen {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100dvh;
		background-size: cover;
		background-position: center;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		z-index: 100;
		background-color: black;
	}

	.spinner {
		width: auto !important;
		max-height: 100px !important;
		max-width: 100px !important;
	}

	.spinner.subtle-pulse {
		width: 300px !important;
		height: auto !important;
		max-width: 300px !important;
		max-height: none !important;
		animation: subtle-pulse 2s ease-in-out infinite;
	}

	@keyframes subtle-pulse {
		0%,
		100% {
			opacity: 1;
			transform: scale(1);
		}
		50% {
			opacity: 0.7;
			transform: scale(0.96);
		}
	}

	.lottie-container {
		width: 200px !important;
		height: 200px !important;
		max-width: 80vw !important;
		max-height: 80vh !important;
		position: relative;
		z-index: 1;
	}

	.lottie-container :global(canvas) {
		display: block;
	}
</style>
